import React from 'react';
import { MapPin } from 'lucide-react';
import ModulePage from './ModulePage';

const scanChecks = (w, input) => [
  { label: 'Google Bedrijfsprofiel', passed: !!input.heeft_google_profiel, detail: input.heeft_google_profiel ? 'Profiel aanwezig' : 'Niet gevonden — onzichtbaar in Google Maps' },
  { label: 'Locatie in regio', passed: !!input.locatie, detail: input.locatie ? `Actief in ${input.locatie}` : 'Geen locatie opgegeven' },
];

export default function LokaalPage() {
  return (
    <ModulePage
      category="lokaal"
      title="Lokale Zichtbaarheid"
      subtitle="Worden gevonden door klanten in uw regio"
      icon={MapPin}
      color="#D4A017"
      scanChecks={scanChecks}
    />
  );
}
